export default __webpack_public_path__ + "static/media/InventoryIcon.2fdbfbad.svg";